import * as React from 'react';
// @ts-expect-error
import type {SelectBaseProps} from 'react-select';

import {colors} from '../../colors/colors';
import {SelectPickerGeneric} from '../../select-picker-generic/select-picker-generic';
import type {NoOptionsMessageProps} from '../../select-picker-generic/select-picker-generic';

import styles from './select-with-icon.module.css';

export type SelectWithIconOption = {
    value: string;
    label: string;
    icon?: React.ComponentType<any> | null | undefined;
    isDisabled?: boolean;
    title?: string | null | undefined;
};

export type Props = SelectBaseProps & {
    value?: string | null | undefined;
    options: SelectWithIconOption[];
    onChange: (value: string) => void;
    selectRef?: any;
    controlIcon?: React.ComponentType<any>;
    // For using the component as a dropdown of options that trigger actions
    resetAfterSelect?: boolean;
    noBorder?: boolean;
    customNoOptionsMessage?: NoOptionsMessageProps;
};

export function SelectWithIcon(props: Props) {
    // isMulti and isClearable throw a flow error on Select Picker Generic
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {isMulti, isClearable, onBlur, value, selectRef, ...restProps} = props;

    function formatOptionLabel(option: SelectWithIconOption) {
        let icon;
        if (option.icon) {
            const Icon = option.icon;
            icon = <Icon alignCenter={true} size={14} />;
        }

        return (
            // @ts-expect-error
            <div title={option.title} className={styles['select-with-icon-option']}>
                {icon}
                <div className={styles.label}>{option.label}</div>
            </div>
        );
    }

    const localStyles = {
        // @ts-expect-error
        control: (base) => ({
            ...base,
            '&:hover': {
                borderColor: colors.greyLt,
            },
            border: `1px solid ${colors.formBorder}`,
            borderRadius: 3,
        }),
    } as const;

    const selectedValue = props.resetAfterSelect
        ? null
        : // If the value is not in the options, we should return null otherwise users of the select
          // won't be able to forcibly clear the value by passing in null as an option
          // @ts-expect-error
          props.options.find((option) => option.value === value) || null;

    return (
        <SelectPickerGeneric
            {...restProps}
            value={selectedValue}
            // @ts-expect-error
            onChange={(option) => {
                props.onChange(option.value);
            }}
            options={props.options}
            styles={localStyles}
            formatOptionLabel={formatOptionLabel}
            isSearchable={false}
            ref={selectRef}
            customNoOptionsMessage={props.customNoOptionsMessage}
        />
    );
}
